import { lazy } from 'react';

const BigMissionSection = lazy(() => import('../BigMissionSection'));

const BigMissionSectionLazy = () => {
  return <BigMissionSection />;
};

export default BigMissionSectionLazy; 